export { deterrenceCommandMutation } from "./commands";
export { useTriggerDeterrence } from "./hooks";
export { deterrenceCommandEndpoint, commandsResource, CommandBody, CommandResponse } from "../client-messages/commands";
export type { CommandPathParams } from "../client-messages/commands";
export type { DeterrenceDevice } from "../g2-fleet-messages/commands";
export {
  DETERRENCE_TEST_DEVICES,
  DETERRENCE_TEST_HOLD_MS,
  DETERRENCE_TEST_SENT_MESSAGE,
  deterrenceTestPrompt,
  deterrenceTestStateFor,
  emptyDeterrenceTestState,
  finishDeterrenceTest,
  isDeterrenceTestBusy,
  isDeterrenceTestHeld,
  releaseLapsedDeterrenceTests,
  startDeterrenceTest,
  type DeterrenceTestPrompt,
  type DeterrenceTestState,
} from "./deterrence-test";
